import { render } from "./Footer.vue?vue&type=template&id=f80a5352&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=f80a5352&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/epr-survey-builder/Vue_Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80a5352"]])

export default __exports__